import { cn } from '@/lib/utils';

/**
 * RangeSlider — cienki suwak zakresu panelu stylów.
 *
 * UWAGA (dług biblioteki UI): biblioteka prymitywów admin SPA nie ma jeszcze
 * odpowiednika slidera, a `<input type="range">` jest blokowany regułą
 * `no-restricted-syntax` (§4.12). Trzymamy tu jeden natywny element range i
 * przez to jedno miejsce przejdzie migracja, gdy powstanie prymityw `Slider`.
 */
interface RangeSliderProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  className?: string;
  'aria-label'?: string;
}

export function RangeSlider({
  min,
  max,
  step = 1,
  value,
  onChange,
  className,
  'aria-label': ariaLabel,
}: RangeSliderProps) {
  return (
    // eslint-disable-next-line no-restricted-syntax -- brak prymitywu Slider w bibliotece UI (patrz JSDoc)
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      aria-label={ariaLabel}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      className={cn('h-1 accent-accent-500 cursor-pointer', className)}
    />
  );
}
